import { stringifyEntityRef, parseEntityRef } from '@backstage/catalog-model';
import { defaultComponentRefContext } from './ComponentUtils.esm.js';
import { isObject } from 'lodash';

function assertUnreachable(_x) {
  throw new Error("Didn't expect to get here");
}
function combinePredicates(predicates) {
  return (t) => {
    return predicates.map((filter) => {
      var _a;
      return (_a = filter == null ? void 0 : filter(t)) != null ? _a : true;
    }).every(Boolean);
  };
}
function enumKeys(obj) {
  return Object.keys(obj).filter((k) => Number.isNaN(+k));
}
function stringifyAnyEntityRef(entityRef, entityRefContext = defaultComponentRefContext) {
  if (typeof entityRef === "string") {
    return stringifyEntityRef(parseEntityRef(entityRef, entityRefContext));
  } else if (entityRef.namespace !== void 0 && entityRef.kind !== void 0) {
    return stringifyEntityRef(entityRef);
  } else if (entityRef.apiVersion !== void 0) {
    return stringifyEntityRef(entityRef);
  }
  return stringifyEntityRef(
    parseEntityRef(entityRef, entityRefContext)
  );
}
function humanizeAnyEntityRef(entityRef, entityRefContext = defaultComponentRefContext) {
  let minifiedRef = stringifyAnyEntityRef(entityRef, entityRefContext);
  if (entityRefContext.defaultKind !== void 0) {
    const kind = entityRefContext.defaultKind.toLowerCase();
    minifiedRef = minifiedRef.replace(`${kind}:`, "");
  }
  if (entityRefContext.defaultNamespace !== void 0) {
    const namespace = entityRefContext.defaultNamespace.toLowerCase();
    minifiedRef = minifiedRef.replace(`${namespace}/`, "");
  }
  return minifiedRef;
}
function entityEquals(a, b, entityRefContext = defaultComponentRefContext) {
  const parsedA = stringifyAnyEntityRef(a, entityRefContext);
  const parsedB = stringifyAnyEntityRef(b, entityRefContext);
  return parsedA === parsedB;
}
function nullsToUndefined(obj) {
  if (obj === null) {
    return void 0;
  }
  if (isObject(obj)) {
    for (let key in obj) {
      obj[key] = nullsToUndefined(obj[key]);
    }
  }
  return obj;
}

export { assertUnreachable, combinePredicates, entityEquals, enumKeys, humanizeAnyEntityRef, nullsToUndefined, stringifyAnyEntityRef };
//# sourceMappingURL=types.esm.js.map
